import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Self-hosted brand type (Bedrock): Geist for UI/display, Geist Mono for numbers.
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
